export default __webpack_public_path__ + "static/media/Ct10.9a222c6e.png";